import Api from '@/services/Api'

export default {
  createList (data) {
    return Api().post('playlists', data)
  },
  fetchLists () {
    return Api().get('playlists')
  },
  fetchList (id) {
    return Api().get('playlists/' + id)
  },
  removeEntry (listId, entryId) {
    return Api().delete('playlists/' + listId + '/entries/' + entryId)
  },
  addEntry (listId, spotifyId) {
    let data = {
      entries: [{
        spotify_id: spotifyId
      }]
    }
    return Api().post('playlists/' + listId + '/entries', data)
  },
  update (listId, title, isPublished, isPrivate) {
    return Api().patch('playlists/' + listId, {
      title: title,
      is_published: isPublished,
      is_private: isPrivate
    })
  },
  publish (listId, isPublished) {
    return Api().patch('playlists/' + listId, {is_published: isPublished})
  }
}



// WEBPACK FOOTER //
// ./src/services/ListsService.js